export const tableHeadings = [ 'Title', 'Brand', 'SKU', 'Category', 'Retail', 'Resell', 'URL'];